import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { PostcodeMapsModule } from './postcode-maps.module';
import { EAreasComponent } from '../../components/manage-eareas/manage-eareas.component';

const routes: Routes = [
  { path: '', component: EAreasComponent, data: { title: 'Manage Engineius Regions' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EAreasRoutingModule {}

@NgModule({
  imports: [
    EAreasRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    PostcodeMapsModule,
  ],
  declarations: [EAreasComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EAreasModule {}
